import { actualFolder } from "../tab_options/background/ImageSelector";

import bg_01 from "../../images/bg/bg-02.jpg";
import bg_02 from "../../images/bg/bg-06.jpg";
import bg_03 from "../../images/bg/bg-08.jpg";
import bg_04 from "../../images/bg/bg-09.jpg";
import bg_05 from "../../images/bg/bg-11.jpg";

export const imagesJSON = [
	{
		full: bg_01,
		thumbnail: "",
		name: "bg-01",
		fav: false,
	},
	{
		full: bg_02,
		thumbnail: "",
		name: "bg-02",
		fav: false,
	},
	{
		full: bg_03,
		thumbnail: "",
		name: "bg-03",
		fav: false,
	},
	{
		full: bg_04,
		thumbnail: "",
		name: "bg-04",
		fav: false,
	},
	{
		full: bg_05,
		thumbnail: "",
		name: "bg-05",
		fav: false,
	},
];

export const loadBackgroundImages = async () => {
	if (localStorage.getItem("images")) {
		let images = JSON.parse(localStorage.getItem("images"));
		for (const image of images) {
			actualFolder.files.push({
				full: image.full,
				thumbnail: image.thumbnail,
				name: image.name,
				fav: image.fav,
			});
		}
	}
}